import { useMount } from 'ahooks';
import { useMemo } from 'react';

import { implog } from '@/api/implog';
// import welcomebg from '@/assets/modal/welcome_bg.webp';
import Button from '@/components/button';
import BlurryLoadingImage from '@/components/progressive-img';
import globalStore from '@/stores/store';
import { isGuestUser } from '@/utils/utils';

import styles from './styles.module.less';

const WelcomeModal = (modal, onClose) => {
  const {
    initialAwardconfig,
    initialState: { isLogin }
  } = globalStore;
  const { mobilereg, guestreg } = initialAwardconfig;

  useMount(() => {
    implog('welcome_modal_show');
  });

  const amount = useMemo(() => {
    if (isGuestUser()) {
      return guestreg;
    }

    return mobilereg;
  }, [isLogin, initialAwardconfig]);

  // const getTitle = () => {
  //   if (__PRODUCT_NAME__ === 'goldSlot') return '7GoldSlots.com';
  //   if (window?.privateConfig?.hz) return 'TIGETSLOT';
  //   return '7USSLOT.com';
  // };

  return (
    <div className={styles.container}>
      <BlurryLoadingImage
        loading="lazy"
        className={styles.bg}
        src={`${window?.imgPrefix || ''}/img/modal/welcome_bg.webp`}
      />
      <div className={styles.bigtitle}>
        <div>WELCOME</div>
      </div>
      <div className={styles.main}>
        <div className={styles.title}>
          <div className={styles.primart_title}>{window?.privateConfig?.title || '7USslot'}</div>
          <div>The platform has obtained a</div>
          <div>US gaming license.</div>
        </div>
        <div className={styles.card}>
          <div>1. New users will receive $ {amount} as initial funds.</div>
          <div>2. Recharge any amount to become VIP and enjoy cash withdrawals.</div>
        </div>
        <div className={styles.btn}>
          <Button
            type="success"
            onClick={() => {
              implog('welcome_modal_click');
              modal.resolve({ onClose });
            }}
          >
            Earn $ {amount}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default WelcomeModal;
